export default __webpack_public_path__ + "static/michal-4ed8385aaa3f4d6f906e4db36598c253.png";